export default {"src":"/_next/static/media/hq-logo-1.8ec04e82.svg","height":64,"width":540};